/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Typography } from "@mui/material";
import { ContentZoneContext } from "cms/components/context/index";
import { ComponentAvatar } from "cms/components/layout/header/component-avatar";
import { ComponentEditorHeaderButtons } from "cms/components/layout/header/component-editor-header-buttons";
import { ComponentEditorLabel } from "cms/components/layout/header/component-editor-header-label";
import { ComponentReuseIcon } from "cms/components/layout/reuse/reused-icon/component-reuse-icon";
import { useContext } from "react";
import { useComponentConfig } from "cms/models/hooks/use-components-config";

/**
 * @type {import('react').FC<ComponentEditorHeaderProps>}
 */
const ComponentEditorHeader = (props) => {
    const { children } = props;

    const { component, hideLabel } = useContext(ContentZoneContext);
    let { label, type } = component || {};
    const componentConfig = useComponentConfig(type);
    const title = componentConfig?.label;

    return (
        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <div
                style={{ display: "flex", flexDirection: "row", width: "100%" }}
                className='simplicity-composer-header-group'
            >
                <div
                    style={{
                        display: "flex", flexDirection: "row", alignItems: "center",
                        width: "100%", marginRight: "16px",
                    }}
                    className='simplicity-composer-header-subgroup'
                >
                    <ComponentAvatar />
                    <div>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>

                            <Typography className='simplicity-composer-header-text'>
                                {title}
                            </Typography>

                            <ComponentReuseIcon />

                        </div>

                        {!hideLabel &&
                            <ComponentEditorLabel
                                defaultLabel={label}
                            />}

                    </div>
                </div>
                <ComponentEditorHeaderButtons />
            </div>
            {children}
        </div>
    );
};

export { ComponentEditorHeader };


/**
 * @typedef {object} ComponentEditorHeaderProps
 * @property {import('react').ReactNode} children
 */
